export default __webpack_public_path__ + "0454203f26b33fc02e2b686b317aab3d.svg";